import { all, takeEvery, put, call } from 'redux-saga/effects';
import { IRequestParams, ICollectionResponse } from '@dash/apiInstance';
import ApiInstance from 'src/helpers/apiInstance';
import { sendRequest } from '../../../../../../../helpers/saga';
import notifications from '../../../../../../../redux/notifications/actions';
import { logger } from '../../../../../../../helpers/logger';
import actionTypes from './actionTypes';
import actions from './actions';
import { tableConfig } from '../../../../../../../settings';
import { ICard, ILoadCardsPathParams } from './types';
import { LoadCardsRequestAction } from './actions.d';

const unitApi = new ApiInstance('units/:id/credits');
const subunitApi = new ApiInstance('subunits/:id/credits');

function* loadCredits({ payload }: LoadCardsRequestAction<ILoadCardsPathParams, {}>) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id, type } = payload;

    const api = type === 'subUnit' ? subunitApi : unitApi;

    const result: ICollectionResponse<ICard> = yield call<any, IRequestParams<ILoadCardsPathParams, {}>, string>(
      sendRequest,
      api.get,
      { search: { page, pageSize, column, order, filter }, pathParams: { id } },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      yield put(
        actions.loadCreditsSuccess({
          credits: result?.data?.records,
          total: result?.data?.total,
          filteredTotal: result?.data?.filteredCount,
          sortableColumns: result?.data?.sortableColumns,
        }),
      );
    } else {
      yield put(actions.loadCreditsError());
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.LOAD_CREDITS_REQUEST, loadCredits)]);
}
